import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

// Swiper docs: https://swiperjs.com/api/

$(document).ready(function () {
	$('.module-case-slider .swiper-container').each(function () {
		initSlide(this)
	})

	$('.module-slider .swiper-container').each(function () {
		initSlide(this)
	})

	$('.module-banner-slider .swiper-container').each(function () {
		initSlide(this)
	})
	updateSliders()
})
// make sure slides fit window when all content has loaded
$(window).on('load', function () {
	updateSliders()
})

function initSlide(slide, userOptions) {
	let SliderWrapper = $(slide).closest('.swiper-container-wrapper');
	let defaultOptions = {
		watchOverflow: true,
		observer: true,
	}
	let options = Object.assign((userOptions || defaultOptions), {
		pagination: {
			el: SliderWrapper.find('.swiper-pagination')[0],
			type: 'fraction',
			clickable: true,
		},
		navigation: {
			nextEl: SliderWrapper.find('.swiper-button-next')[0],
			prevEl: SliderWrapper.find('.swiper-button-prev')[0],
		},
		scrollbar: {
			el: SliderWrapper.find('.swiper-scrollbar')[0],
		},
	})
	return new Swiper(slide, options)
}

export function makeSlider(className, options) {
	return initSlide(className, options)
}

function updateSliders() {
	window.dispatchEvent(new Event('resize'));
	$(window).trigger('resize');
	setTimeout(function () {
		// just to be sure
		window.dispatchEvent(new Event('resize'));
		$(window).trigger('resize');
	}, 300)
}